import React from 'react'

const Epilepsy = () => {
  return (
    <>
      



      <div className="dr-header">
        <div className="header-contant">
          <h1> Services</h1>
          <p>Doctor {" > "}  Epilepsy </p>
        </div>
      </div>

      <div className="diabp">
        <h1>Epilepsy</h1>
        <div className="bp-row">
          <div className="bp-col">
            <p>
            At our clinic, we have all the expertise and equipment to evaluate epilepsy in children. We carry out standard and sleep deprived EEGs, ambulatory prolonged EEGs and videotelemetry. For inpatient three day Videotelemetry, I admit children to Neurospinal Hospital for a thorough evaluation. 
            </p>
            <p>
            Brain imaging with epilepsy protocol is carried out a Neurospinal hospital and City Hospital. At ACPN, we have plans of establishing a comprehensive Ketogenic diet service for refractory epilepsy. Children are also evaluated for insertion of vagal nerve stimulators and appropriate referrals are made to Neurosurgeons based in Bansal Hospital, Bhopal.
            </p>
           
          </div>
          <div className="bp-col">
            <img src="./img/epilepsy.jpg" alt="" />
          </div>
        </div>
      </div>
    </>
  )
}

export default Epilepsy
